<template>
    <div class="py-4 container-fluid">
        <div v-if="!isLoading" class="row">
            <div class=" row">
                <div class="col-12">
                    <argon-alert v-if="showAlert" color="danger" :dismissible="true" @close-alert="closeAlert">
                        <strong>Incidencia!</strong> Eliminada correctamente!
                    </argon-alert>
                    <incidencias-table :incidences="incidences" />
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import IncidenciasTable from "./components/IncidencesTable.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
    name: "incidencias",
    components: {
        IncidenciasTable,
        ArgonAlert
    },
    data() {
        return {
            isLoading: true,
            incidences: undefined,
            showAlert: false,
        };
    },
    created() {
        this.plain
            .get(`/incidences`)
            .then((response) => {
                if (response.data.length !== 0) this.incidences = response.data;
                else this.incidences = [];
                this.isLoading = false;
            })
            .catch((err) => {
                this.incidences = [];
                this.isLoading = false;
                console.log(err);
            });
    },
    methods: {
        deleteItemIncidence(incidenceID) {
            this.showAlert = true;
            this.incidences = this.incidences.filter(({ id }) => id !== incidenceID);
            // console.log("incidenceS incidenceS incidenceS");
            // console.log(this.incidences);
            window.scrollTo(0, 0);
            this.plain.delete(`/incidences/${incidenceID}`)
                .then(() => {
                    // console.log("Comentario eliminado de la base de datos");
                })
                .catch((error) => {
                    console.log("Error al eliminar comentario de la base de datos", error);
                });

        },
        closeAlert() {
            this.showAlert = false;
        },
        refreshIncidences() {
            this.isLoading = true
            this.plain
                .get(`/incidences`)
                .then((response) => {
                    if (response.data.length !== 0) this.incidences = response.data;
                    else this.incidences = [];
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.incidences = [];
                    this.isLoading = false;
                    console.log(err);
                });
        }
    },
};
</script>